import { render, staticRenderFns } from "./ReservationStatus.vue?vue&type=template&id=86d8c520&"
import script from "./ReservationStatus.vue?vue&type=script&lang=js&"
export * from "./ReservationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports